import { useCallback, useState } from 'react';
import type { AcaoPausaRetomada } from '../types/negociacaoDetailUiTypes';
interface UseConfirmacaoPausaRetomadaParams {
  isPaused: boolean;
  onPausar: () => Promise<boolean>;
  onRetomar: () => Promise<boolean>;
}
export function useConfirmacaoPausaRetomada({
  isPaused,
  onPausar,
  onRetomar
}: UseConfirmacaoPausaRetomadaParams) {
  const [acao, setAcao] = useState<AcaoPausaRetomada | null>(null);
  const [isConfirmando, setIsConfirmando] = useState(false);
  const abrir = useCallback((proxima: AcaoPausaRetomada) => setAcao(proxima), []);
  const fechar = useCallback(() => setAcao(null), []);
  const confirmar = useCallback(async () => {
    if (!acao || isConfirmando) return;
    // O snapshot do caso é atualizado em segundo plano e o status pode mudar com o modal aberto:
    // confirmar uma ação que já não corresponde ao estado atual só fecha o modal.
    if (acao === 'retomar' !== isPaused) {
      setAcao(null);
      return;
    }
    setIsConfirmando(true);
    try {
      const sucesso = acao === 'pausar' ? await onPausar() : await onRetomar();
      if (sucesso) setAcao(null);
    } finally {
      setIsConfirmando(false);
    }
  }, [acao, isConfirmando, isPaused, onPausar, onRetomar]);
  return {
    acao,
    isConfirmando,
    abrir,
    fechar,
    confirmar
  };
}